export const getTotalPaid = ({ price, discount = 0 }) => {
    const totalPrice = Number(price);
    const totalDiscount = Number(discount);

    return (totalPrice - totalDiscount).toFixed(2);
  };